<template>
  <div class="listeProd">
    <div class="date-range-picker">
      <label for="lp-search">N° affaire :</label>
      <input type="text" id="lp-search" v-model="searchTerm" placeholder="Rechercher…">

      <label for="lp-commande">N° de commande :</label>
      <input type="text" id="lp-commande" v-model="commandeTerm" placeholder="Rechercher…">

      <span class="filter-separator"></span>

      <select v-model="period" @change="onPeriodChange" class="select-period">
        <option value="">Toutes périodes</option>
        <option value="aujourd_hui">Aujourd'hui</option>
        <option value="hier">Hier</option>
        <option value="semaine_cours">Semaine en cours</option>
        <option value="semaine_precedente">Semaine précédente</option>
        <option value="mois_cours">Mois en cours</option>
        <option value="mois_precedent">Mois précédent</option>
        <option value="mois_suivant">Mois suivant</option>
        <option value="mois_flottant">Mois flottant</option>
        <option value="deux_derniers_mois">Deux derniers mois</option>
        <option value="annee_precedente">Année précédente</option>
        <option value="annee_cours">Année en cours</option>
        <option value="personnalisee">Personnalisée</option>
      </select>

      <template v-if="period === 'personnalisee'">
        <label for="start-date">Date de début :</label>
        <input type="date" id="start-date" v-model="startDate" @change="searchProd(1)">
        <label for="end-date">Date de fin :</label>
        <input type="date" id="end-date" v-model="endDate" @change="searchProd(1)">
      </template>
    </div>

    <div class="hPasse">
      <p>Temps total passé pour cette période : <strong>{{ formatDureeHHMM(tempsTotal) }}</strong> (h:min)</p>
    </div>

    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchProd(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <div class="links container-fluid">
     
    </div>
  
    <table class="utilisateursListe mb-5">
      <thead>
        <tr>
          <th @click="handleColumnSort('affaire')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='affaire'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Affaire</span></div></th>
          <th @click="handleColumnSort('desa')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='desa'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Désignation</span></div></th>
          <th @click="handleColumnSort('client')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='client'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Client</span></div></th>
          <th @click="handleColumnSort('etat_prod')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='etat_prod'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>État de la production</span></div></th>
          <th @click="handleColumnSort('temps')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='temps'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Temps passé (h)</span></div></th>
          <th @click="handleColumnSort('quantite')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='quantite'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Quantité</span></div></th>
          <th @click="handleColumnSort('signalement')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='signalement'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
          </svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg></span><span>Signalé le</span></div></th>
          <!--  <th>Espace perso</th> -->
        </tr>
      </thead>
      <tbody>
        <!-- Check if the articles array is empty -->
        <template v-if="productions.length === 0">
          <tr>
            <td colspan="8" class="text-center">Pas d'opérations enregistrés.</td>
          </tr>
        </template>
      
        <!-- Render table rows for each article -->
        <template v-else>
              <tr v-for="(production, index) in filteredProductions" :key="production.id" class="productions" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'"> 
                <td>{{ production.affaire }}</td>
                <td>{{ production.desa }} <br> {{ production.desa2 }} <br> {{ production.desa3 }}</td>
                <td>{{ production.client }}</td>
                <td>{{ production.etat_prod }}</td>
                <td>
                  <div class="temps-cell">
                    <span>{{ formatDureeHHMM(production.temps) }}</span>
                    <button v-if="loggedInRole === 'admin'" class="btn-edit-temps" @click="openEditTemps(production)" title="Modifier le temps">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                  </button>
                  </div>
                </td>
                <td>{{ production.quantite }}</td>
                <td>{{ formatDate(production.signalement) }}</td>
              <!--    <td>
                  <RouterLink :to="getUserLink(utilisateur)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
                  <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                  </svg></RouterLink>
                </td> -->
              </tr>
        </template>
      </tbody>
      
    </table>
   
      <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchProd(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>

    <!-- Modal édition du temps -->
    <div v-if="editingProduction" class="modal-overlay" @click.self="editingProduction = null">
      <div class="modal-edit-temps">
        <h3>Modifier le temps passé</h3>
        <p>Affaire : <strong>{{ editingProduction.affaire }}</strong></p>
        <label for="edit-temps">Temps (HH:MM)</label>
        <input id="edit-temps" type="time" step="60" v-model="newTemps" />
        <div class="modal-actions">
          <button class="btn-save" @click="saveTemps">Enregistrer</button>
          <button class="btn-cancel" @click="editingProduction = null">Annuler</button>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import { formatDureeHHMM, heuresMinutesToDecimal, decimalToHeuresMinutes } from '@/utils/duree.js'



export default {
  data() {
    return {
      productions: [],
      tempsTotal: '',
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      commandeTerm: '',
      isLoading: false,
      idClient: '',
      emailClient: '',
      sortColumn: 'signalement',
      sortDirection: 'desc',
      startDate: '',
      endDate: '',
      period: '',
      loggedInRole: null,
      editingProduction: null,
      newTemps: '',
    }
  },
  mounted() {
    this.idClient = this.$route.params.idClient

    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }

    axios.post('https://www.simef.fr/espace-client/api/getUtilisateur.php', {
      id: this.idClient
    })
    .then(response => {
      this.emailClient = response.data.client;
      this.searchProd(this.currentPage);
    })
    .catch(error => {
      console.error(error);
      
    });

   
    
  }, 

    
  computed: {
    filteredProductions() {
      const term = this.searchTerm.trim().toLowerCase();
      const commande = this.commandeTerm.trim().toLowerCase();
      return this.productions.filter(p => {
        const matchesTerm = !term || (
          (p.affaire   || '').toLowerCase().includes(term) ||
          (p.desa      || '').toLowerCase().includes(term) ||
          (p.desa2     || '').toLowerCase().includes(term) ||
          (p.desa3     || '').toLowerCase().includes(term) ||
          (p.client    || '').toLowerCase().includes(term) ||
          (p.etat_prod || '').toLowerCase().includes(term)
        );
        const matchesCommande = !commande || (p.cocde || '').trim().toLowerCase().includes(commande);
        return matchesTerm && matchesCommande;
      });
    },
  },
  methods: {
    formatDureeHHMM,
    searchProd(page) {
      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/getProductions.php', {
        page: page,
        searchTerm: '',
        clientEmail: this.emailClient,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        startDate: this.startDate,
        endDate: this.endDate,
      })
      .then(response => {
        this.productions = response.data.productions;
        this.tempsTotal = response.data.sumQuantite;
        this.nb_pages = response.data.nb_pages;
        this.currentPage = page;

      })
      .catch(error => {
        console.error(error);
        

      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        // Reverse the sorting direction if the same column is clicked again
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Sort the clicked column in ascending order by default
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      // Call the searchArticles method with the current page and sorting parameters
      this.searchProd(this.currentPage);
    },
    onPeriodChange() {
      const today = new Date();
      const fmt = d => d.toISOString().slice(0, 10);
      const monday = (d) => {
        const day = d.getDay() || 7;
        const m = new Date(d);
        m.setDate(d.getDate() - day + 1);
        return m;
      };
      switch (this.period) {
        case '':
          this.startDate = '';
          this.endDate = '';
          break;
        case 'aujourd_hui': {
          this.startDate = fmt(today);
          this.endDate = fmt(today);
          break;
        }
        case 'hier': {
          const h = new Date(today); h.setDate(today.getDate() - 1);
          this.startDate = fmt(h); this.endDate = fmt(h);
          break;
        }
        case 'semaine_cours': {
          const lun = monday(today);
          const dim = new Date(lun); dim.setDate(lun.getDate() + 6);
          this.startDate = fmt(lun); this.endDate = fmt(dim);
          break;
        }
        case 'semaine_precedente': {
          const lunPrec = monday(today); lunPrec.setDate(lunPrec.getDate() - 7);
          const dimPrec = new Date(lunPrec); dimPrec.setDate(lunPrec.getDate() + 6);
          this.startDate = fmt(lunPrec); this.endDate = fmt(dimPrec);
          break;
        }
        case 'mois_cours': {
          const d1 = new Date(today.getFullYear(), today.getMonth(), 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_precedent': {
          const d1 = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth(), 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_suivant': {
          const d1 = new Date(today.getFullYear(), today.getMonth() + 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 2, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_flottant': {
          const d1 = new Date(today); d1.setDate(today.getDate() - 30);
          this.startDate = fmt(d1); this.endDate = fmt(today);
          break;
        }
        case 'deux_derniers_mois': {
          const d1 = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'annee_precedente': {
          this.startDate = `${today.getFullYear() - 1}-01-01`;
          this.endDate = `${today.getFullYear() - 1}-12-31`;
          break;
        }
        case 'annee_cours': {
          this.startDate = `${today.getFullYear()}-01-01`;
          this.endDate = `${today.getFullYear()}-12-31`;
          break;
        }
        case 'personnalisee':
          return;
      }
      this.searchProd(1);
    },
    openEditTemps(production) {
      this.editingProduction = production;
      const { heures, minutes } = decimalToHeuresMinutes(production.temps);
      this.newTemps = `${String(heures).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    saveTemps() {
      const [heures, minutes] = String(this.newTemps || '').split(':');
      const tempsVal = heuresMinutesToDecimal(heures, minutes);
      if (isNaN(tempsVal) || tempsVal < 0) return;
      axios.post('https://www.simef.fr/espace-client/api/updateTempsProduction.php', {
        id: this.editingProduction.id,
        temps: tempsVal,
      })
      .then(response => {
        if (response.data && response.data.success) {
          this.editingProduction.temps = tempsVal;
          this.editingProduction = null;
          this.searchProd(this.currentPage);
        }
      })
      .catch(error => {
        console.error(error);
      });
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;

  .temps-cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-edit-temps {
    margin: 0 0 0 6px !important;
    padding: 4px 8px !important;
    svg {
      margin-right: 0 !important;
    }
  }

  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .modal-edit-temps {
    background: #fff;
    border-radius: 8px;
    padding: 28px 32px;
    min-width: 300px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.18);
    display: flex;
    flex-direction: column;
    gap: 12px;

    h3 {
      margin: 0 0 4px;
      color: $primary;
    }

    input[type="number"], input[type="time"] {
      width: 100%;
      padding: 6px 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 1rem;
    }

    .modal-actions {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
    }

    .btn-save {
      background: $primary;
      color: #fff;
      border: none;
      border-radius: 4px;
      padding: 6px 16px;
      cursor: pointer;
      &:hover { opacity: 0.85; }
    }

    .btn-cancel {
      background: #eee;
      color: #333;
      border: none;
      border-radius: 4px;
      padding: 6px 16px;
      cursor: pointer;
      &:hover { background: #ddd; }
    }
  }

  .date-range-picker {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    button {
      margin-left: 20px;
    }
    .filter-separator {
      display: inline-block;
      width: 1px;
      height: 24px;
      background: #ccc;
      margin: 0 8px;
    }
  }
  .hPasse {
    strong {
      font-weight: 900;
      font-size: 1.2rem;
      color: #2b358d !important;
    }
  }
</style>
